module.exports = __webpack_public_path__ + "img/e-referral.e33db38f.png";